export class AuthenticationDataBM {
    public constructor(token: string) {
        this.Token = token;
    }

    Token: string;
}
